import { ReactNode } from 'react'

const SystemUserDataTableRow = ({ icon, rowName, rowValue }: { icon: ReactNode; rowName: string; rowValue: string }) => {
  return (
    <div className="system-user-data-table-row-container">
      <div className="system-user-data-table-row-item">
        {icon}
        <div className="system-user-data-table-row-item-name">{rowName}</div>
      </div>
      <div className="system-user-data-table-row-item">
        <div className="system-user-data-table-row-item-value">{rowValue}</div>
      </div>
    </div>
  )
}

export default SystemUserDataTableRow
